export default __webpack_public_path__ + "static/media/icon-download.199d85ce.svg";